<template>
  <v-app dark>
      <v-container fluid>
        <v-layout align-center justify-center row fill-height>
          <v-flex sm4>
            <v-toolbar>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-form>
                  <v-text-field type="text" label="Enter your username" v-model="loginInfo.user" required></v-text-field>
                  <v-text-field type="password" label="Enter your password" v-model="loginInfo.password" required></v-text-field>
                  <v-layout justify-end>
                    <v-btn v-on:click="login()">Login</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
  </v-app>
</template>

<script>
import dispatcher from './dispatcher/dispatcher'

export default {
  data () {
    return {
      loginInfo: {
        user: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      dispatcher.login(this.loginInfo)
      .then((result) => {
        if (result.cookie) {
          this.$emit('authenticated', true)
          document.cookie = result.cookie
          this.$router.push({ name: 'home' })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Login.vue